/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 crtttt.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Crtttt(props) {
  const { nodes, materials } = useGLTF('/media/models/crtttt.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.crt.geometry} material={materials['Material_0.001']} />
    </group>
  )
}

useGLTF.preload('/media/models/crtttt.glb')
